import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { toast } from 'sonner';
import { login } from '../api/auth.api';
import type { LoginPayload } from '../types/auth.types';

function isSafeInternalPath(path: string | undefined): path is string {
  if (!path?.startsWith('/')) return false;
  if (path.startsWith('//') || path.startsWith('/\\')) return false;

  return !/^\/login(?:[/?]|$)/.test(path);
}

export function useLogin() {
  const navigate = useNavigate();
  const search = useSearch({ from: '/_public/login' });

  return useMutation({
    mutationFn: (payload: LoginPayload) => login(payload),
    onSuccess: () => {
      toast.success('Login successful');
      const target = isSafeInternalPath(search.redirect) ? search.redirect : '/';
      void navigate({ to: target });
    },
  });
}
